import React from "react";

const NoAction = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.9987 63.5413C42.5404 63.5413 36.457 57.458 36.457 49.9997C36.457 42.5413 42.5404 36.458 49.9987 36.458C57.457 36.458 63.5404 42.5413 63.5404 49.9997C63.5404 57.458 57.457 63.5413 49.9987 63.5413ZM49.9987 42.708C45.9987 42.708 42.707 45.9997 42.707 49.9997C42.707 53.9997 45.9987 57.2913 49.9987 57.2913C53.9987 57.2913 57.2904 53.9997 57.2904 49.9997C57.2904 45.9997 53.9987 42.708 49.9987 42.708Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M77.082 63.5413C75.3737 63.5413 73.957 62.1247 73.957 60.4163V39.583C73.957 37.8747 75.3737 36.458 77.082 36.458C78.7904 36.458 80.207 37.8747 80.207 39.583V60.4163C80.207 62.1247 78.7904 63.5413 77.082 63.5413Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M20.8346 94.7913C9.91797 94.7913 1.04297 85.9163 1.04297 74.9997C1.04297 64.083 9.91797 55.208 20.8346 55.208C31.7513 55.208 40.6263 64.083 40.6263 74.9997C40.6263 85.9163 31.7513 94.7913 20.8346 94.7913ZM20.8346 61.458C13.3763 61.458 7.29297 67.5413 7.29297 74.9997C7.29297 82.458 13.3763 88.5413 20.8346 88.5413C28.293 88.5413 34.3763 82.458 34.3763 74.9997C34.3763 67.5413 28.293 61.458 20.8346 61.458Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M16.6669 82.2913C15.6252 82.2913 14.5835 81.7497 14.0001 80.7914C13.1251 79.333 13.5835 77.3746 15.0835 76.4996L18.2502 74.5831C18.5419 74.4164 18.7502 74.0413 18.7502 73.708V69.833C18.7502 68.1247 20.1669 66.708 21.8752 66.708C23.5835 66.708 25.0002 68.1247 25.0002 69.833V73.708C25.0002 76.2496 23.6253 78.6663 21.4586 79.958L18.2919 81.8747C17.7919 82.1664 17.2085 82.2913 16.6669 82.2913Z"
        fill="var(--color-stroke-active)"
      />
      <path
        d="M70.832 86.4587H35.4154C33.707 86.4587 32.2904 85.042 32.2904 83.3337C32.2904 81.6253 33.707 80.2087 35.4154 80.2087H70.832C82.7487 80.2087 88.5404 74.417 88.5404 62.5003V37.5003C88.5404 25.5837 82.7487 19.792 70.832 19.792H29.1654C17.2487 19.792 11.457 25.5837 11.457 37.5003V63.3337C11.457 65.042 10.0404 66.4587 8.33203 66.4587C6.6237 66.4587 5.20703 65.042 5.20703 63.3337V37.5003C5.20703 22.292 13.957 13.542 29.1654 13.542H70.832C86.0404 13.542 94.7904 22.292 94.7904 37.5003V62.5003C94.7904 77.7087 86.0404 86.4587 70.832 86.4587Z"
        fill="var(--color-stroke-active)"
      />
    </svg>
  );
};

export default NoAction;
